/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LegalRequirementsCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React from "react";
import LinkCard from "./LinkCard";
import { componentStyle } from "../../../config/appTheme";
import helper from "../../../utils/helper";
import CustomToolTip from "../../../components/infoButton/CustomToolTip";

function LegalRequirementsCard({
  legalRequirementList,
  showCheckBox,
  selectValue,
  setSelectValue,
  unlinkLegalRequirement,
  selectedComponentDetails,
}) {
  return (
    <Box
      sx={{
        pt: 1,
        flex: 0,
        height: "21rem",
        overflow: "auto",
      }}
    >
      {legalRequirementList.map((legalReq, index) => {
        const renderKeyValue = ({ key, value }) => {
          return (
            <Box>
              {/* <Typography
                sx={{ ...componentStyle.font.text, textAlign: "left" }}
              >{`${key} - ${value || "-"}`}</Typography> */}
              <CustomToolTip
                length={200}
                style={{ ...componentStyle.font.text, textAlign: "left" }}
              >
                {`${key} - ${value || "-"}`}
              </CustomToolTip>
            </Box>
          );
        };
        return (
          <Box
            sx={{
              mb: 0.5,
            }}
            key={index}
          >
            <LinkCard
              showCheckBox={showCheckBox}
              selectedComponentDetails={selectedComponentDetails}
              selectValue={selectValue}
              setSelectValue={setSelectValue}
              unlinkLegalRequirement={unlinkLegalRequirement}
              legalReq={legalReq}
              rightContent={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    p: 1,
                    pb: 0,
                  }}
                >
                  <Typography sx={componentStyle.font.cardHeadder}>
                    Legal Standard:
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {renderKeyValue({ key: "Name", value: legalReq?.name })}
                    {renderKeyValue({
                      key: "Number",
                      value: legalReq?.standard_number,
                    })}
                    {renderKeyValue({
                      key: "Revision",
                      value: legalReq?.revision,
                    })}
                  </Box>
                </Box>
              }
              leftContent={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    flexDirection: "column",
                    p: 1,
                  }}
                >
                  <Typography sx={componentStyle.font.cardHeadder}>
                    Chapter:
                  </Typography>
                  <Typography
                    sx={{
                      ...componentStyle.font.keyValueContent,

                      textAlign: "right",
                    }}
                  >
                    {legalReq.chapter}
                  </Typography>
                </Box>
              }
              bottomContent={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    p: 1,
                  }}
                >
                  <Typography sx={componentStyle.font.cardHeadder}>
                    Legal Requirement:
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {renderKeyValue({
                      key: "Number",
                      value: legalReq?.req_number,
                    })}
                    {renderKeyValue({
                      key: "Description",
                      value: helper.truncate(legalReq?.description, 150),
                    })}
                    {renderKeyValue({
                      key: "Version",
                      value: legalReq?.lr_version,
                    })}
                  </Box>
                </Box>
              }
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default LegalRequirementsCard;
